// -------------------------------------------------------------
//
// WARNING: DO NOT EDIT THIS MANUALLY.
// Use @field({decoder: any, ...NextVersion)} in your code.
//
// -------------------------------------------------------------
export const Version = 407;
import { AutoEncoder } from '@simonbackx/simple-encoding';
AutoEncoder.skipDefaultValuesVersion = 10000; // todo
/**
 * Use this in development when making changes to fields.
 * On release, the version will get bumped and the usages of NextVersion will be replaced by that version.
 * Note: during developent all the saved fields with NextVersion will get cleared on the next release.
 */
globalThis.NextVersion = {
    // optional: true,
    version: Version,
    /* defaultValue() {
        return this.upgrade ?? undefined;
    }, */
};
//# sourceMappingURL=Version.js.map